import React from "react"
import { View, ScrollView, StyleSheet } from "react-native"
import { theme } from "@common/theme/theme"
import TextM from "@common/components/text/TextM"
import { LinearGradient } from "expo-linear-gradient"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import TouchableRippleM from "@common/components/button/TouchableRippleM"
import ErrorTextM from "../components/text/ErrorTextM"

export const ErrorScreen = ({
    title = "Oups ! Un problème est survenu",
    type = "error", // error, warning
    error,
    buttonText = "Réessayer",
    onButtonPress,
}) => {
    const insets = useSafeAreaInsets()

    const buttonColors =
        type === "error"
            ? [theme.colors.primary, theme.colors.primaryDark]
            : [theme.colors.warning, theme.colors.warningLighter]

    return (
        <View style={[styles.container, { paddingTop: insets.top }]}>
            <ScrollView
                contentContainerStyle={[
                    styles.scrollContent,
                    { width: "100%" },
                ]}
                showsVerticalScrollIndicator={false}
            >
                <View style={styles.errorContainer}>
                    <View style={styles.errorIcon}>
                        <TextM fontSize={48}>⚠️</TextM>
                    </View>

                    <TextM
                        fontSize={20}
                        fontWeight="Bold"
                        color={theme.colors.primary}
                        style={styles.errorTitle}
                    >
                        {title}
                    </TextM>

                    <View style={styles.errorCard}>
                        <ErrorTextM errorData={error} />
                    </View>

                    {!!onButtonPress && (
                        <TouchableRippleM
                            onPress={onButtonPress}
                            style={[{ borderRadius: 15, overflow: "hidden" }]}
                        >
                            <LinearGradient
                                colors={buttonColors}
                                start={{ x: 0, y: 0 }}
                                end={{ x: 1, y: 1 }}
                                style={{
                                    paddingVertical: 15,
                                    paddingHorizontal: 30,
                                    alignItems: "center",
                                }}
                            >
                                <TextM
                                    fontSize={16}
                                    fontWeight="Bold"
                                    color={theme.colors.white}
                                >
                                    {buttonText}
                                </TextM>
                            </LinearGradient>
                        </TouchableRippleM>
                    )}
                </View>
            </ScrollView>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: theme.colors.whiteAlmost,
        alignItems: "center",
    },
    scrollContent: {
        flexGrow: 1,
        alignSelf: "center",
        alignItems: "center",
        paddingVertical: 40,
        paddingBottom: 100,
    },

    errorContainer: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        paddingHorizontal: 20,
        width: "100%",
    },
    errorIcon: {
        marginBottom: 20,
    },
    errorTitle: {
        textAlign: "center",
        marginBottom: 20,
    },
    errorCard: {
        backgroundColor: theme.colors.white,
        padding: 20,
        borderRadius: 16,
        borderWidth: 1,
        borderColor: theme.colors.errorLight,
        marginBottom: 30,
        width: "100%",
        alignItems: "center",
    },
    errorText: {
        textAlign: "center",
        lineHeight: 20,
    },
})
